<template>
  <div
    id="app"
    ref="app"
    :class="appClass"
    :style="appStyle"
  >
    <ExpireTips v-if="plainResultData && plainResultData.status === 'expire'" :plain-result-data="plainResultData" />
    <template v-else>
      <template v-if="tmpData">
        <template v-if="replayLoading">
          <bxs-default-page :large="!0" type="comment" text="视频加载中..." />
        </template>
        <template v-else>
          <!-- 封面 -->
          <cover v-if="isCoverShow" :plan="plan" @close="closeCover" />
  
          <template v-if="isPolicyCheck">
            <policy-check-infor :uuid="uuid" />
          </template>
          <template v-else>
            <result-banner
              :title="title"
              :tmp-data="tmpData"
              :card="card"
              :token="token"
              :uuid="uuid"
              :is-for-presentation="isForPresentation"
              @done="isResultBannerDone = true"
            />
          </template>
  
          <!-- 人/险种信息汇总 -->
          <person
            v-if="personData"
            ref="person"
            :is-policy="isPolicyCheck"
            :person-data="personData"
            :table-data="tableData"
            :common-data="productCommonData"
            :total-baof="totalBaof"
            @new-insure-detail="handleOpenNewInsureDetail"
          />
  
          <!-- 责任种类图标 -->
          <category
            v-if="!showType && insTypeList.length"
            :prop-category-sort-list="categorySortList"
            :prop-category-sort="categorySort"
            :prop-category-list="insTypeList"
            :total-baof="totalBaof"
            :tag-list="tagList"
          />
  
          <!-- 右侧模式切换 -->
          <toggle-temp-right
            v-if="tmpData && !isSingleInsuranceShow && !isForPresentation"
            v-show="isScreenCaptureShow"
            :show-type="showType"
            :kind="kind"
            data-stat-id="qhxsms"
            :data-stat-ep="JSON.stringify({ productId: insuranceTypeId })"
            @toggle="toggle"
            @toggle-kind="kind = $event"
          />
  
          <!-- 责任 -->
          <keep-alive>
            <template v-if="showType">
              <ins-result
                ref="insResult"
                :template="tmpData"
                :product-name-list="productNameListData"
                :miniprogram="miniprogram"
                @set-instype="
                  insTypeList = $event
                  insTypeInit = true
                "
                @open-disease="openDiseaseBubble"
                @open-terms="openTermsBubble"
              />
            </template>
            <template v-else>
              <ins-type-result
                ref="insTypeResult"
                :template="tmpData"
                :kind="kind"
                :product-name-list="productNameListData"
                @set-instype="
                  insTypeList = $event
                  insTypeInit = true
                "
                @set-accIns="accType = $event"
                @open-disease="openDiseaseBubble"
              />
            </template>
          </keep-alive>
  
          <!-- [保单年检]单险种责任 -->
          <single-insurance
            v-model="isSingleInsuranceShow"
            :template-data="tmpData"
          />
  
          <!-- 病种 -->
          <sliding
            :show="disease.show"
            :over-height="true"
            iconfont="icon-close_line"
            @close="disease.show = false"
          >
            <disease-type
              ref="diseaseType"
              :porp-height="disease.height"
              :show="disease.show"
              :products="tmpData.liabilities"
              :active-path="disease.activePath"
              :is-for-presentation="isForPresentation"
              @change-product="setDiseasePaneHeight"
            />
          </sliding>
  
          <!-- 利益演示 -->
          <demons
            ref="demons"
            :is-for-presentation="isForPresentation"
            :prop-cur-year="curYear"
            :prop-insured-age="insuredAge"
            :cur-insurances="tmpData"
            @update-year="shareYear = $event"
            @set-interest-key="
              interestKeyList = $event
              interestKeyInit = true
            "
            @update-account-map="setAccountMap"
          />
  
          <!-- 广告 -->
          <advertising :position="9" :relation-id="insuranceTypeId" />
  
          <!-- 条款 -->
          <!-- <terms-list
            ref="termsList"
            v-if="termsList.length > 0"
            :prop-uuid="uuid"
            :prop-id="termsActiveId"
            :prop-name="card.name"
            :miniprogram="miniprogram"
            @send-delta="syncDelta"
            @close="termsActiveId = null"
          />-->
          <insurance-clause :uuid="uuid" :miniprogram="miniprogram" />
  
          <!-- [名片] 小程序 -->
          <miniprogram-footer
            v-if="miniprogram && !isWeapp"
            :data="footData"
            @generate="isExportShow = true"
            @interpretation="interpretationScheme = true"
          />
  
          <!-- [名片] 常规 -->
          <card-function-bar
            v-else-if="footData"
            :is-support-record-screen="isSupportRecordScreen"
            :is-screen-capture="isScreenCaptureShow"
            :is-for-presentation="isForPresentation"
            :is-trades="tradesType"
            :is-policy-check="isPolicyCheck"
            :data="footData"
            :recording-state="recordingState"
            :interaction-on="tmpData.interactionSwitchOn"
            @generate="isExportShow = true"
            @generate-image="exportPbShow = 2"
            @share="handleShare"
            @record="recordScreenShow = true"
            @interpretation="interpretationScheme = true"
          />
  
          <!-- 名词解释 -->
          <name-explain
            v-if="interestKeyInit && insTypeInit && !isPolicyCheck"
            ref="nameExplain"
            :liability-tag-list="insTypeList"
            :interest-key-list="interestKeyList"
            :sort-list="sortList"
            @done="isNameExplainDone = true"
            @send-delta="syncDelta"
          />
  
          <!-- 风险提示 -->
          <risk
            v-if="tmpData"
            ref="riskPrompt"
            :risk-type="riskType"
            :type-list="insTypeList"
            :sort-list="sortList"
            :category-sort="categorySort"
          />
  
          <!-- 用户二维码 -->
          <qrcode v-if="!isScreenCaptureShow" :url="shareLink" />
  
          <!-- 回流弹窗 -->
          <reflow-box
            :uuid="uuid"
            :insurance-type-id="insuranceTypeId"
            :insured-info="personData.insuredInfo"
            :is-pre-invitation="isPreInvitationShow"
          />
  
          <!-- 续保保费 -->
          <bxs-bottom-sheets
            v-model="newInsure.show"
            class="newinsure-bottom-sheets"
            title="续保保费"
            :use-b-scroll="false"
            :prevent-scroll-through="true"
          >
            <new-insure-detail :new-insure="newInsure" />
          </bxs-bottom-sheets>
  
          <!-- 导出 -->
          <!-- 图片。文档改由 export-selection 处理 -->
          <plan-to-export
            v-model="exportPbShow"
            :miniprogram="miniprogram"
            @screen-capture="screenCapture"
          />
          <!-- 文档 -->
          <export-selection v-model="isExportShow" :miniprogram="miniprogram" />
  
          <!-- 讲解方案选择（录屏、同屏讲解）  -->
          <scheme-selection
            v-model="interpretationScheme"
            :miniprogram="miniprogram"
            :is-support-record-screen="isSupportRecordScreen"
            :interaction-on="tmpData.interactionSwitchOn"
            @record-screen="recordScreenShow = true"
            @invitation="isPreInvitationShow = true"
            @support-warning="isSupportShow = true"
            @share="handleToInterpretation"
            @began-to-record-screen="$refs.recordScreen.handleCount(true)"
            @wechat-invitation="handleToInterpretation(true)"
          />
  
          <!-- [录屏] -->
          <record-screen
            v-if="!isForPresentation"
            ref="recordScreen"
            v-model="recordScreenShow"
            @close="
              recordScreenShow = false
              isBoardShow = false
            "
            @to-start="
              recordScreenShow = false
              recordingState = true
            "
            @to-end="
              recordingState = false
              isBoardShow = false
            "
          />
  
          <!-- 画笔（录屏、同屏讲解） -->
          <div
            v-if="isForPresentation || recordingState"
            class="floating-toolbelt-wrapper"
          >
            <div
              v-if="(isForPresentation && isHost) || recordingState"
              class="drawing-btn floating-toolbelt"
              :class="{ cur: isBoardShow }"
              @click="handleToggleBoard"
              @touchmove.prevent
            >
              <i class="iconfont icon-write_line" />画笔
            </div>
            <drawing-board
              v-if="isBoardShow"
              ref="drawingBoard"
              :is-host="isHost"
              @send-delta="syncDelta"
            />
          </div>
  
          <!-- 引导 -->
          <!-- 同屏引导 -->
          <!-- <screen-driver
            v-if="
              BC.isBxs && !CM.getUrlParam('roomId') && tmpData.interactionSwitchOn
            "
          />-->
          <!-- 录屏引导 -->
          <!-- <driver v-if="BC.isBxs" :video-bg="insuranceInfor.videoList[0] && insuranceInfor.videoList[0].bgImg || insuranceInfor.resultVideoImg" /> -->
  
          <!-- [同屏讲解] 工具带 -->
          <presentation-toolbelt
            v-if="isForPresentation"
            v-show="!isBoardShow"
            ref="presentationToolbelt"
            :is-replay="isReplay"
            :is-host="isHost"
            :wechat-info="plan"
            :agent-info="card"
            :host-user-id="hostUserId"
            @presenter-change="isHost = $event"
            @synchronous-history="synchronousHistory"
            @page-sync="onPageSync"
            @pre-page-sync="onPrePageSync"
            @request-control="isHost = $event"
            @request-host-id="hostUserId = $event"
            @quit-presentation="isForPresentation = false"
            @tim-ready="replayTim = $event"
            @enter-success="savePresentationInfo"
          />
  
          <!-- [同屏讲解] 发起弹窗 -->
          <bxs-popup
            v-model="isPreInvitationShow"
            class="pre-popup"
            :close-on-click-overlay="false"
          >
            <pre-presentation
              @share="handleToInterpretation"
              @close="isPreInvitationShow = false"
            />
          </bxs-popup>
  
          <!-- [同屏讲解] 成功转发弹窗 -->
          <bxs-popup
            v-model="showBeforeJoinConfirmation"
            class="before-join-confirmation"
            :close-on-click-overlay="false"
          >
            <bxs-default-page type="search" text="已经成功转发给您的客户！" />
            <div class="go-to-btn" @click="gotoPresentationPage">
              确定
            </div>
          </bxs-popup>
  
          <!-- 小程序不支持弹窗 -->
          <bxs-popup
            v-model="isSupportShow"
            class="not-support-miniprogram"
            :close-on-click-overlay="false"
          >
            <div class="tips">
              抱歉，小程序暂不支持此功能，请下载保险师APP使用哦
            </div>
            <div class="btn" @click="isSupportShow = false">
              知道了
            </div>
          </bxs-popup>
  
          <!-- [同屏讲解] 高度适配遮罩 -->
          <div
            v-if="isForPresentation && viewOverlayShow"
            class="view-overlay"
            :style="{ height: `${viewOverlayHeight}px` }"
            @touchmove.prevent
          />
  
          <!-- [同屏讲解] 讲解遮罩 -->
          <div
            v-if="isForPresentation && !isHost"
            class="interpretation-over"
            :class="{ lock: isBoardShow }"
            @touchmove.prevent
          />
  
          <!-- [同屏讲解] 同步定位 -->
          <sharing-screen
            v-if="isForPresentation && isSharingScreenShow"
            v-model="elementsTop"
          />
  
          <!-- [同屏讲解] 是否有c，进入讲解房间的入口 -->
          <interpretation-notice
            v-if="
              (BC.isBxs || BC.isToBApp) &&
                !CM.getUrlParam('roomId') &&
                tmpData.interactionSwitchOn
            "
          />
        </template>
  
        <!-- [同屏回放] 遮罩 -->
        <replay-toolbelt
          v-if="isReplay"
          :tim="replayTim"
          :replay-loading="replayLoading"
          :is-board-show="isBoardShow"
          :is-for-presentation="isForPresentation"
          @presenter-change="isForPresentation = $event"
          @reset="reset"
        />
  
        <!-- 自定义分享 -->
        <!-- <action-sheet v-model="isShareShow" /> -->
      </template>
      <bxs-bg v-else :value="BC.isBxs" />
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { get as _get } from 'lodash'
import axios from 'axios'
import Cookies from 'js-cookie'
import VConsole from 'vconsole'
// 分享|授权
import Oauth from 'base/oauth'
import Wechat from 'base/wechat'
import Share from 'base/model/share'
// API|COMMON|BASE
import * as API from 'api/index'
import * as APC from 'api/config'
import * as DOM from 'common/js/dom'
import * as CM from 'common/js/common'
import * as FMT from 'common/js/format'
import logger from 'base/logger'
import * as BC from 'base/config'
import * as CONFIG from './base/config'

// mobileDevice
import UA from 'ua-device'
import { mobileDevice } from 'common/js/mobileDevice'
// 组件
import Sliding from 'base/sliding/sliding'
// 公共
import 'components/global.js'
// 私有
import './components/selfInstall.js'

// 同屏
import pageSyncMixin from './tim-adapter/page-sync-mixin'
// 版本限制
import versionLimit from './base/versionLimit'
// 后台预览
import mgmtPreview from './base/mgmtPreview'
import ExpireTips from '@/pages/planbkTemplatev2/components/expireTips/index.vue'

// - BXS
import { BottomSheets, MessageBox, Popup } from 'bxs-ui-vue'
Vue.use(MessageBox)

export default {
  name: 'App',
  components: {
    Sliding,
    [Popup.name]: Popup,
    [BottomSheets.name]: BottomSheets,
    ExpireTips
  },
  mixins: [pageSyncMixin, versionLimit, mgmtPreview],
  data () {
    return {
      isCoverShow: true,
      isPageDone: false,
      plainResultData: null, // 从接口获取的、未处理的数据
      personData: null,
      tableData: null,
      tmpData: null,
      footData: null,
      showType: 0,
      kind: null,
      plan: {
        sex: '',
        name: '',
        avatar: '',
        nickname: '',
        token: null,
        pbUuid: null,
        salesUuid: null,
        authed: false
      },
      insTypeList: [],
      disease: {
        show: false,
        activePath: [],
        height: 0
      },
      accountsData: [],
      card: {},
      termsList: [],
      accType: false,
      miniprogram: false,
      testGroup: {
        show: false,
        url: '',
        text: '',
        code: 0,
        image: ''
      },
      tagList: [],
      springData: {},
      // defaultBanner: false,
      insuranceInfor: {},
      productCommonData: [],
      termsActiveId: null,
      newInsure: {
        show: false,
        data: {}
      },
      exportPbShow: 0, // 导出文档
      isExportShow: false,
      interpretationScheme: false, // 讲解方案
      interestKeyList: [], // 利益演示字段
      interestKeyInit: false,
      insTypeInit: false,
      recordScreenShow: false,
      recordingState: false,
      isBoardShow: false,
      roomId: null,
      hasPendingInvitation: false,
      isPreInvitationShow: false,
      isSingleInsuranceShow: true,

      isNameExplainDone: false,
      isResultBannerDone: false,

      showBeforeJoinConfirmation: false,
      isForPresentation: !!CM.getUrlParam('roomId'),
      isSupportShow: false, // 不支持小程序弹窗
      isScreenCaptureShow: true,
      shareLink: '', // 分享最终链接

      replayLoading: false,
      isReplay: !!CM.getUrlParam('replay'),
      replayTim: null,
      autoOauth: false,
      fromWyjhs: false
    }
  },
  computed: {
    appClass () {
      const {
        footData,
        tradesType,
        isPageDone,
        miniprogram,
        replayLoading
      } = this
      return {
        higher: footData && tradesType,
        'no-bar': !tradesType && !BC.bApp && !BC.isWeCom && !miniprogram,
        done: isPageDone && !replayLoading
      }
    },
    appStyle () {
      const { viewOverlayShow, viewOverlayHeight } = this
      return { 'margin-bottom': `${viewOverlayShow ? viewOverlayHeight : 0}px` }
    },
    // 单款可投保产品
    tradesType () {
      const { footData, tmpData } = this
      const productLen =
        tmpData &&
        Array.isArray(tmpData.liabilities) &&
        tmpData.liabilities.length

      return (
        footData &&
        Array.isArray(footData.trades) &&
        footData.trades.length === 1 &&
        productLen === 1
      )
    },
    // 保单年检
    isPolicyCheck () {
      return this.pbType === 'annual_survey'
    },
    // 需要记录
    needToRecord () {
      const { autoOauth, isReplay, fromWyjhs } = this
      return BC.inWechat && autoOauth && !isReplay && !fromWyjhs
    },
    // 计算同屏模块位置组件是否显示
    isSharingScreenShow () {
      const { isResultBannerDone, isNameExplainDone } = this
      return isResultBannerDone && isNameExplainDone
    }
  },
  watch: {
    exportPbShow: {
      handler (value) {
        this.syncDelta({ pbData: { exportPbShow: value } })
      }
    },
    'disease.show': {
      handler (value) {
        this.stopBodyScroll = value
        !value && this.syncDelta({ pbData: { isDiseasesShow: value } })
      }
    },
    termsActiveId: {
      handler (value) {
        this.stopBodyScroll = value
      }
    },
    replayLoading: {
      handler (value) {
        this.CM.loading(value)
      }
    }
  },
  created () {
    this.BC = BC
    this.CM = CM
    if (BC.isWeCom) {
      this.miniprogram = false
      this.initPage()
    } else if (BC.inWechat && wx.miniProgram) {
      wx.miniProgram.getEnv(res => {
        this.miniprogram = res.miniprogram
        this.initPage()
      })
    } else {
      this.miniprogram = false
      this.initPage()
    }

    if (window.appBridge && appBridge.checkAppFeature('NEED_TEXT_ZOOM')) {
      appBridge.needTextZoom()
    }
  },
  methods: {
    initPage () {
      this.initSearch()
      this.applyTheme()
      const { uuid, token, isReplay, inGroup, miniprogram, needToRecord } = this
      const vm = this
      if (!uuid) return
      this.fetchData({ uuid })((id, heartSec) => {
        // TODO: 为了快速实现的快捷做法
        this.plan.token = token
        this.plan.pbUuid = this.uuid
        this.plan.salesUuid = this.card.userUuid
        // end TODO
        if (needToRecord) {
          Oauth({
            token,
            wxMpAppid: BC.wxMpAppid,
            componentAppid: BC.componentAppid
          }).then(res => {
            if (!res) return
            vm.saveOperate().then(res => {
              vm.clientUuid = res.clientUuid
              vm.buried(id, heartSec)
            })
          })
          // 三招两式
          this.qaFeedback()
        } else {
          // 银保小程序行为轨迹
          this.saveOperate()
          this.buried(id, heartSec)
        }
        // [app][wxwork]
        this.actionSheetInit()
        // [wechat]
        this.wechatShareInit()
      })
      if (
        miniprogram ||
        !inGroup ||
        isReplay ||
        BC.isWeCom ||
        BC.isMiniBankInsurance
      ) {
        return
      }
      Oauth({
        token,
        wxMpAppid: BC.wxMpAppid,
        componentAppid: BC.componentAppid
      }).then(res => {
        this.plan.authed = true
        this.qaFeedback()
        if (!res) return
        API.getClientInfo({ token }).then(
          ({ data: { success, data } } = { data: {} }) => {
            if (success && data) {
              this.plan.avatar = data.headimgurl
              this.plan.nickname = data.nickname
            }
          }
        )
      })
    },
    initSearch () {
      this.coverTimer = null
      this.theme = CM.getUrlParam('theme')
      this.curYear = parseInt(CM.getUrlParam('year')) || 0
      this.dfSort = CM.getUrlParam('dfSort')
      this.uuid = CM.getUrlParam('uuid')
      this.cardUuid = CM.getUrlParam('cardUuid')
      this.userUuid = CM.getUrlParam('userUuid')
      this.token = CM.getToken(CONFIG.TOKEN_KEY, CONFIG.TIMESTAMP_KEY)
      this.inGroup = CM.getUrlParam('inGroup')
      this.autoOauth = CM.getUrlParam('autoOauth')
      this.pathUuid = CM.getUrlParam('pathUuid')
      // 保单托管-详情页
      this.isWeapp = CM.getUrlParam('weapp')
      // 三招两式
      this.tsType = CM.getUrlParam('tsType')
      this.tsTypeId = CM.getUrlParam('tsTypeId')
      // 保单年检
      this.pbType = CM.getUrlParam('pbType')
      // 公众号
      this.fromWyjhs = CM.getUrlParam('fromWyjhs') == 1
    },
    applyTheme () {
      const dmHtml = document.getElementsByTagName('html')[0]
      if (!dmHtml) {
        return
      }
      if (this.theme) {
        DOM.addClass(dmHtml, this.theme)
      }
    },
    // 获取数据
    fetchData ({ uuid }) {
      const { isPolicyCheck, userUuid } = this
      return (callbk = () => {}) => {
        const params = { uuid }
        // 三招两式名片
        if (userUuid) {
          params.userUuid = userUuid
        }
        API.getResult(params).then(
          ({ data: { data, success, info } } = { data: {} }) => {
            if (success) {
              this.plainResultData = data
              const { heartSec, insuranceType, resultData, status, createTime, visitTimes } = data
              if (status === 'expire') {
                setTimeout(() => {
                  window.WeiyiStatSDK.submit('gq', {
                    type: isPolicyCheck ? 'BDNJ' : 'JGY',
                    time: createTime,
                    visitTimes
                  })
                }, 3000)
              }

              const card = data.card || {}
              data.trades = []
              this.matchData(data)

              this.oauthExtendMsg = insuranceType.name
              this.shareInfo = {
                name: card.name,
                img: isPolicyCheck
                  ? BC.POLICY_WECHAT_SHARED_LOGO
                  : insuranceType.wechatSharedLogoUrl
              }
              this.cardUuid = card.uuid
              this.insuranceInfor = resultData.title
                ? Object.assign(insuranceType, { name: resultData.title })
                : insuranceType
              callbk(resultData.insuranceTypeId, heartSec)

              // 线上启动 VConsole：被保人姓名 === vc_debug
              const _personOrderList = _get(data, 'resultData.personData.personOrderList') || []
              const _insuredInfo = _personOrderList.find(p => p.key === 'insuredInfo')
              const _insuredName = _get(_insuredInfo, 'name')
              if (_insuredName ==='vc_debug') {
                const vConsole = new VConsole()
                vConsole.setOption({ disableLogScrolling: true })
                const _network = _get(vConsole, 'pluginList.network')
                const _disableLogScrolling = _get(vConsole, 'option.disableLogScrolling')
                if (_network) {
                  _network.scrollToBottom = function () {
                    if (!_disableLogScrolling) {
                      const $box = vConsole.$.one('.vc-content')
                      $box.scrollTop = $box.scrollHeight - $box.offsetHeight
                    }
                  }
                }
              }
            }
          }
        )
        this.visitTs(uuid)
      }
    },
    // 条款
    fetchTermsData ({ key, name }, username = '') {
      API.liabilities({}, `${key}/liabilities`).then(
        ({ data: { success, data } } = { data: {} }) => {
          this.singleInsurance.name = name
          this.singleInsurance.imgList = data
          this.singleInsurance.show = true
          this.singleInsurance.url = `${
            BC.baseTermUrl
          }?nw=1&name=${username}&termsId=${key}`
        }
      )
    },
    // 赋值
    matchData (result) {
      const {
        descShow,
        calData,
        personData,
        tableData,
        accountsData,
        accountMap,
        // termsData,
        productNameList,
        productCommonData
      } = FMT.formatCalculateData(result.resultData, BC.normalizeKeys)
      // const commonData = result.resultData.commonData || {}
      // 用户信息
      this.personData = personData
      this.productCommonData = productCommonData
      personData.insuredInfo &&
        (this.insuredAge = parseInt(personData.insuredInfo.age))
      this.tableData = tableData
      this.totalBaof = parseFloat(result.resultData.totalBaof)

      // 追加领取
      this.accountsData = accountsData

      result.accountMap = accountMap
      result.calData = calData
      result.insuredAge = this.insuredAge
      result.descShow = descShow
      // 计划书信息
      this.title = this.settingPbTitle(result)
      this.setPageTitle(this.isPolicyCheck ? '保单信息' : this.title)

      // const pbRestBannUrl = result.insuranceType.pbRestBannUrl
      // const defaultBanner = BC.DEFAULT_BANNER[result.resultData.theme]
      // if (pbRestBannUrl) {
      //   this.headBanner = pbRestBannUrl
      // } else {
      //   this.headBanner = defaultBanner
      //   this.defaultBanner = defaultBanner
      // }
      this.tmpData = result
      this.productNameListData = productNameList

      // ID
      this.insuranceTypeId = result.resultData.insuranceTypeId
      let categorySort = result.resultData.categorySort
      categorySort =
        Object.keys(BC.insTypeOrders).indexOf(categorySort) >= 0
          ? categorySort
          : 'normal'
      this.categorySort = categorySort
      // 风险提示
      this.riskType = result.insuranceType.riskType
      // 计划书标签
      this.tagList = result.insuranceType.tagList
      // pc端分享，配置+经纪人
      this.pcDisplay = true // commonData.pcDisplay && result.card.memeber
      // 责任排序
      const _sortList = result.categorySortList
      this.categorySortList = _sortList
      const sortList = (this.sortList =
        Array.isArray(_sortList) && _sortList.length
          ? _sortList
          : BC.insTypeOrders[categorySort])

      const { accInsList } = FMT.formatLiabilitiesData(
        result.liabilities,
        sortList,
        BC.insTypeName,
        accountMap
      )
      const bAcc = accInsList[0] && accInsList[0].length
      this.accType = bAcc

      // 默认显示模式
      if (this.isForPresentation) {
        this.showType = 1
      } else {
        if (bAcc) {
          this.showType = 0
          this.kind = 1
        } else {
          if ((result.trades || []).length) {
            this.showType = 1
          } else {
            if (this.dfSort || this.dfSort === 0) {
              this.showType = +this.dfSort
            } else if (result.resultData.displayFormatSort) {
              this.showType = BC.SHOW_TYPE[result.resultData.displayFormatSort]
            }
          }
        }
      }

      // 条款
      // this.termsList = termsData
      this.card = result.card || {}
      this.footData = {
        insuranceTypeId: this.insuranceTypeId,
        trades: result.trades,
        ...result.card
      }
    },
    // 关闭封面 {Boolean} hand 手动关闭
    closeCover (hand) {
      if (hand) {
        this.isCoverShow = false
        this.isPageDone = true
        setTimeout(() => {
          if (BC.bApp) {
            this.isCoverShow = false
            this.isPageDone = true
          }
          this.isCoverShow = false
        }, BC.ANIMATION_TIME)
        return
      }
      if (this.coverTimer) clearTimeout(this.coverTimer)
      const endTime = Date.now()
      const stuffTime = endTime - window.startTime
      if (stuffTime >= BC.COVER_TIME - BC.ANIMATION_TIME) {
        this.isCoverShow = false
        this.isPageDone = true
      } else {
        this.coverTimer = setTimeout(() => {
          this.isCoverShow = false
          this.isPageDone = true
          setTimeout(() => {
            this.isCoverShow = false
          }, BC.ANIMATION_TIME)
        }, BC.COVER_TIME - stuffTime - BC.ANIMATION_TIME)
      }
    },
    // 切换显示类型 {Number} showType 显示类型
    toggle (showType) {
      this.showType = showType
      this.syncDelta({ pbData: { showType } })
    },
    // 分享初始化[app][wxwork-A][miniprogram-webview]
    async actionSheetInit () {
      let {
        uuid,
        theme,
        title,
        shareInfo: { name, img },
        cardUuid,
        // inGroup,
        tmpData
      } = this
      const vm = this
      const addParams = {
        cardUuid,
        inGroup: true,
        isShareFormWeApp: 1
      }
      if (BC.isBroker) {
        addParams.app = 'Broker'
      } else if (BC.isToBApp || BC.isWeCom) {
        addParams.app = Cookies.get('appId')
      }
      const link = (this.shareLink = CM.getUrlByAddingParam(
        addParams,
        location.href
      ))
      const mp = (this.mp = {
        webPageUrl: 'http://www.winbaoxian.com/',
        userName: 'gh_db166d39960f',
        path: `/pages/result/index?uuid=${uuid}&theme=${theme}&t=1`,
        title: '买保险优选服务',
        description: `${APC.reg ? '' : '(测试版)'}${title}，${name}为您定制`,
        imageUrl:
          'http://img.winbaoxian.com/autoUpload/planbook/__87080b709204b35.png',
        miniProgramType: APC.reg ? 0 : 2
      })

      let baseConfig = {
        desc: `${name}${
          this.isPolicyCheck ? BC.POLICY_SHARE_DECS : BC.SHARE_DECS
        }`,
        bizChannel: 'jhs',
        taskId: 'share_planbook',
        title,
        link,
        img
      }
      let qqConfig = Object.assign({}, baseConfig, {
        action: 'qq_friends'
      })
      let wtConfig = Object.assign({}, baseConfig, {
        action: 'wechat_timeline'
      })
      let wfConfig = Object.assign({}, baseConfig, {
        action: 'wechat_friends'
      })
      // let wcConfig = Object.assign({}, baseConfig, {
      //   action: 'miniProgramData',
      // })
      let dingConfig = Object.assign({}, baseConfig, {
        action: 'ding_talk'
      })

      const callback = async config => {
        const _share = new Share(
          Object.assign({}, config, {
            link: (() => {
              let linkAddParame = {
                dfSort: this.showType
              }
              if (this.shareYear || this.shareYear === 0) {
                linkAddParame.year = this.shareYear
              }
              return CM.getUrlByAddingParam(linkAddParame, link, true)
            })()
          })
        )

        if (['wechat_friends', 'wechat_timeline'].indexOf(config.action) >= 0) {
          const appParams = await this.getAppParams()
          _share.shareUrl = CM.getUrlByAddingParam(
            appParams,
            _share.shareUrl,
            true
          )
        }
        API.addPbCount({
          uuid,
          type: 'pb_share'
        })
        API.completeMission({
          SourceId: uuid,
          missionCode: 'share_planbook'
        })
        API.resultShare({ uuid })
        window.WeiyiStatSDK.submit('share')
        return _share
      }
      // wxwork
      if (BC.isWeCom && window.WeCom && WeCom.initWeComConfig) {
        let linkAddParame = await this.getAppParams()
        linkAddParame.dfSort = this.showType
        if (this.shareYear || this.shareYear === 0) {
          linkAddParame.year = this.shareYear
        }
        // 隐藏名片
        linkAddParame.nocard = 1
        WeCom.initWeComConfig(
          {
            title: baseConfig.title,
            desc: baseConfig.desc,
            imgUrl: baseConfig.img,
            link: CM.getUrlByAddingParam(linkAddParame, link, true),
            success: () => {
              API.resultShare({ uuid })
            }
          },
          true
        )
        return
      }
      // 小程序
      if (this.miniprogram) {
        let linkAddParame = {
          dfSort: this.showType,
          nobar: 1 // 隐藏功能栏
        }
        if (this.shareYear || this.shareYear === 0) {
          linkAddParame.year = this.shareYear
        }
        const miniShareURL = CM.getUrlByAddingParam(linkAddParame, link, true)
        // 银保小程序
        if (BC.isMiniBankInsurance && WeCom.initMiniConfig) {
          WeCom.initMiniConfig({
            title: baseConfig.title,
            desc: baseConfig.desc,
            imgUrl: baseConfig.img,
            link: miniShareURL
          })
        } else {
          wx.miniProgram.postMessage({
            data: {
              shareConfig: {
                title: baseConfig.title,
                imageUrl: '', // baseConfig.img，图片尺寸问题不使用，使用页面截图
                shareUrl: miniShareURL
              }
            }
          })
        }
        return
      }

      if (BC.bApp && appBridge && appBridge.checkAppFeature(CONFIG.AP_ASHEET)) {
        const asConfig = {
          title:
            BC.isBxs && new Date() < new Date('2020/12/31 23:59:59')
              ? '即日起至12月底，转发计划书，即送3宝石（每人每天赠送上限1次）'
              : '',
          channel: 'jhs',
          shareGroup: [
            new Share(
              Object.assign({}, wtConfig, {
                cb: callback.bind(this, wtConfig)
              })
            ),
            new Share(
              Object.assign({}, wfConfig, {
                cb: callback.bind(this, wfConfig)
              })
            ),
            new Share(
              Object.assign({}, qqConfig, {
                cb: callback.bind(this, qqConfig)
              })
            )
          ],
          actionGroup: [{ action: 'text_zoom' }]
        }
        const miniCfg = {
          action: 'miniProgramData',
          ...mp
        }
        const dingCfg = new Share(
          Object.assign({}, dingConfig, {
            cb: callback.bind(this, dingConfig)
          })
        )
        // bxs 加入小程序and钉钉
        if (BC.isBxs) {
          asConfig.shareGroup.splice(2, 0, miniCfg, dingCfg)
        }
        // 责任条数
        let count = 0
        tmpData.liabilities.forEach(item => {
          const insLiabs = item.insuranceLiabilities
          if (!Array.isArray(insLiabs)) return
          insLiabs.forEach(({ liabilities }) => {
            if (!Array.isArray(liabilities)) return
            liabilities.forEach(liab => {
              if (liab.description1) count++
            })
          })
        })
        if (BC.isBxs || BC.isToBApp) {
          asConfig.actionGroup = asConfig.actionGroup.concat([
            {
              action: {
                action: 'custom_feedback',
                title: '反馈',
                icon: CONFIG.icons.feedback
              },
              customActionHandler (action) {
                if (vm.isForPresentation) return
                location.href = `${
                  APC.pbfUrl
                }/planBook/projectGroup/feedback/index.html?nw=1&type=8&planbookId=${
                  vm.tmpData.resultData.insuranceTypeId
                }`
              }
            }
          ])
          // 支持同屏
          if (BC.isBxs || BC.isYjjApp) {
            asConfig.actionGroup.push({
              action: {
                action: 'invitation',
                title: '同屏讲解',
                icon: CONFIG.icons.invitation
              },
              customActionHandler (action) {
                if (vm.isForPresentation) return
                vm.isPreInvitationShow = true
              }
            })
          }
          // 支持录屏
          if (this.isSupportRecordScreen) {
            asConfig.actionGroup.push({
              action: {
                action: 'record_screen',
                title: '录制视频',
                icon: CONFIG.icons.recordScreen
              },
              customActionHandler (action) {
                if (vm.isForPresentation) return
                vm.recordScreenShow = true
              }
            })
          }
        }
        this.asConfig = asConfig
        appBridge.commonActionSheet(asConfig)
        if (
          appBridge &&
          appBridge.checkAppFeature('ON_APP_BACK_TO_INPUT_PAGE')
        ) {
          appBridge.onAppBackToInputPage(() => {
            appBridge.commonActionSheet(asConfig)
            this.$refs.recordScreen.getRecordScreenStatus()
          })
        }
      }
    },
    // 打开病种详情
    openDiseaseBubble (path) {
      this.disease.show = true
      path = path || {}
      this.disease.activePath = path
      this.setDiseasePaneHeight()
      this.syncDelta({ pbData: { isDiseasesShow: true, diseasesPath: path } })
    },
    // 打开条款详情
    openTermsBubble (id) {
      this.termsActiveId = id
      this.syncDelta({
        pbData: {
          isClausesShow: true,
          insuranceId: id
        }
      })
    },
    // 设置病种内容高度
    setDiseasePaneHeight () {
      this.$nextTick(() => {
        const itemHeight = parseFloat(
          getComputedStyle(
            document.querySelector('.disease-type .nav-list'),
            null
          ).height
        )
        // let hdHeight = parseFloat(getComputedStyle(document.querySelector('.disease-type .hd'), null).height)
        const navHeight = parseFloat(
          getComputedStyle(
            document.querySelector('.disease-type .navigation'),
            null
          ).height
        )
        const filterHeight = 35 // parseFloat(getComputedStyle(document.querySelector('.disease-type .nav-filter'), null).height)
        //  + hdHeight
        if (this.disease.height === itemHeight + filterHeight + navHeight) {
          return
        }
        this.disease.height = itemHeight + filterHeight + navHeight
      })
    },
    // 设置页面标题
    setPageTitle (title) {
      document.querySelectorAll('title')[0].innerHTML = title
      if (appBridge && appBridge.checkAppFeature('CHANGE_WEBVIEW_TITLE')) {
        appBridge.changeWebviewTitle(title)
      }
    },
    // 设置计划书标题
    settingPbTitle (data = {}) {
      const { tsTypeId, isPolicyCheck } = this
      const { resultData, insuranceType } = data
      let productTitle

      // 投保页填写
      if (
        resultData &&
        resultData.personData &&
        resultData.personData.recipientInfo &&
        resultData.personData.recipientInfo.title &&
        resultData.personData.recipientInfo.shareTitle
      ) {
        return resultData.personData.recipientInfo.shareTitle.substring(0, 30)
      }

      // 多公司产品 且 非三招两式 && 非保单年检
      if (
        !tsTypeId &&
        !isPolicyCheck &&
        resultData &&
        resultData.productGroupList &&
        resultData.productGroupList[0] &&
        resultData.productGroupList[0].prodOrderList
      ) {
        let multipleProd = []
        const prodList = resultData.productGroupList[0].prodOrderList
        if (Array.isArray(prodList)) {
          prodList.forEach((item, index) => {
            const companyName = item.companyName
            if (multipleProd.indexOf(companyName) === -1) {
              multipleProd.push(companyName)
            }
            if (!index) productTitle = item.titleName
          })
        }
        if (multipleProd.length > 1) {
          return '综合保障方案'
        }
      }
      let title = resultData.title || insuranceType.name
      // 对比
      if (resultData.insuranceTypeId == CONFIG.CONTRAST_ID && productTitle) {
        title = productTitle
      }
      if (isPolicyCheck) {
        title = '家庭保单'
      }
      // other & 三招两式
      return title
    },
    setAccountMap (data) {
      const { productId, insuranceId, addAndTakeData } = data
      this.tmpData.accountMap[productId][
        insuranceId
      ].addAndTakeData = addAndTakeData
    },
    // 阅读回执 id 计划书ID
    visitTs (id) {
      let visImg = document.getElementById('transparent')
      if (!visImg || !id) return
      visImg.src = '//img.winbaoxian.com/static/images/planBook/transparent.png'
      visImg.onload = function () {
        API.visitTs({ id })
      }
    },
    // 埋点
    buried (pid, heartSec) {
      let host = window.location.hostname,
        sdk = window.WeiyiStatSDK,
        heartBeatRate = 10000,
        modelResult
      if (!BC.bApp) {
        let userAgent = window.navigator.userAgent
        let output = new UA(userAgent)
        let {
          device: { model }
        } = output
        if (model) {
          model == 'IPHONE' && (model = mobileDevice.model)
        } else {
          model = '未知'
        }
        modelResult = model
      }

      let projectInfo = {
        uuid: this.uuid,
        productId: pid
      }
      modelResult && (projectInfo.model = modelResult)
      // openId 历史遗留
      this.clientUuid && (projectInfo.openId = this.clientUuid)

      if (heartSec && !isNaN(heartSec)) {
        heartBeatRate = heartSec
      }
      // 开发环境心跳关闭
      if (/localhost/.test(location.host) || /192/.test(location.host)) {
        heartBeatRate = 999999
      }
      if (this.isReplay) {
        projectInfo.v = '同屏计划书回放'
      } else if (this.isForPresentation) {
        // 同屏
        projectInfo.v = '同屏计划书'
      }
      if (this.tsType && this.tsTypeId) {
        projectInfo[this.tsType] = this.tsTypeId
      }

      localStorage.removeItem('PlayingVideoMetadata')
      setInterval(() => {
        let vMetadata = localStorage.getItem('PlayingVideoMetadata')
          ? JSON.parse(localStorage.getItem('PlayingVideoMetadata'))
          : null
        if (vMetadata) {
          for (let k in vMetadata) {
            projectInfo[k] = vMetadata[k]
          }
        }
      }, 500)
      sdk &&
        sdk.init({
          pageId: 'JHS_JGY',
          isProduct: /com/.test(host) && /pbf/.test(host),
          heartBeatRate,
          projectInfo,
          // 以下参数为错误上报专用参数
          Vue, // 可选, 也可前置 window.Vue = Vue 来代替
          name: process.env.PKG_NAME, // 必选, package.json 中的 name
          version: process.env.PKG_VERSION // 必选, package.json 中的 versio
        })

      window.onscroll = () => {
        const nScrollTop = DOM.getScrollTop()
        const riskHeight =
          this.$refs.riskPrompt && this.$refs.riskPrompt.$el.clientHeight
        if (
          !this._haveRead &&
          nScrollTop + DOM.getWindowHeight() >=
            DOM.getScrollHeight() - riskHeight
        ) {
          window.WeiyiStatSDK.submit('fxts')
          this._haveRead = true
          // window.onscroll = null
        }
      }
    },
    // 微信分享初始化
    wechatShareInit () {
      const {
        token,
        tmpData,
        autoOauth,
        miniprogram,
        insuranceTypeId,
        isReplay,
        fromWyjhs,
        shareYear,
        showType
      } = this
      // 微信 授权缓存期
      if (
        !BC.inWechat ||
        miniprogram ||
        autoOauth ||
        isReplay ||
        fromWyjhs ||
        BC.isWeCom ||
        BC.isMiniBankInsurance
      ) {
        return
      }
      if (BC.isOutside) {
        // 站外A
        let wxConfig = this.getWxShareConfig()
        let linkAddParame = {
          dfSort: showType,
          SHARE_FROM: BC.outsideAppId
        }
        if (shareYear || shareYear === 0) {
          linkAddParame.year = shareYear
        }
        wxConfig.link = CM.getUrlByAddingParam(linkAddParame, wxConfig.link)
        Wechat(new Share(wxConfig), location.href, BC.wxMpAppid)
        return
      }
      Oauth({
        token,
        wxMpAppid: BC.wxMpAppid,
        componentAppid: BC.componentAppid
      }).then(res => {
        if (!res) return
        this.saveOperate().then(res => {
          this.clientUuid = res.clientUuid
          this.buried(insuranceTypeId, tmpData.heartSec)
        })
      })
    },
    // 保存行为记录、更新分享链接-行为轨迹
    async saveOperate () {
      const {
        uuid,
        token,
        card,
        cardUuid,
        pathUuid,
        oauthExtendMsg,
        insuranceTypeId,
        miniprogram
      } = this
      const baseParams = {
        userStrId: this.userUuid || card.userUuid, // 代理人标识
        source: 4,
        operate: 'view',
        linkId: uuid,
        businessId: insuranceTypeId, // 获客行为产品ID
        dynamicMsg: [oauthExtendMsg], // 获客行为动态文案
        previousOperateUuid: pathUuid, // 上一个分享人的行为UUID，当前接口返回
        jumpUrl: `${location.origin}${
          location.pathname
        }?nw=1&uuid=${uuid}&cardUuid=${cardUuid}`,
        humanPathFlag: true
      }
      if (!BC.inWechat || BC.isOutside) return
      if (miniprogram) {
        // 银保小程序行为轨迹
        if (BC.isMiniBankInsurance && WeCom.initMiniConfig) {
          WeCom.initMiniConfig({
            ...baseParams,
            // 银保小程序特有
            // 指定分享链接上承载 previousOperateUuid 的 key
            pathUuid: 'pathUuid'
          })
          return
        }
        return
      }
      const wxConfig = this.getWxShareConfig()
      try {
        const { data, info } = await API.wxClientSaveOperate({
          appId: BC.wxMpAppid, // 微信授权APP_ID
          token: token,
          userAppId: BC.APPID, // 保险师，独代，企微
          ...baseParams
        })
        logger.warn('[Operate]', info)
        let widthPathLink = CM.setUrlParam(
          'pathUuid',
          data.operateUuid,
          wxConfig.link
        )
        widthPathLink = CM.setUrlParam('isShareFormWeApp', 1, widthPathLink)
        wxConfig.link = CM.getUrlByDeletingParam(
          {
            token: false,
            autoOauth: false
          },
          widthPathLink
        )
        Wechat(new Share(wxConfig), location.href, BC.wxMpAppid)
        return data
      } catch (err) {
        Wechat(new Share(wxConfig), location.href, BC.wxMpAppid)
        logger.warn('[Operate]', err)
        return new Error(err)
      }
    },
    async getAppParams () {
      let appParams = {}
      if (this.appParams && this.appParams.wxMpAppid) {
        return Promise.resolve(this.appParams)
      }
      try {
        const {
          data: { success, data }
        } = await API.getApplicationInfo()
        if (success && data) {
          if (data.wxMpAppid) {
            appParams.wxMpAppid = data.wxMpAppid
          }
          if (data.thirdPlatformAppid) {
            appParams.component_appid = data.thirdPlatformAppid
          }
          this.appParams = appParams
        }
      } catch (e) {
        appParams.wxMpAppid = BC.wxMpAppid
      }
      return Promise.resolve(appParams)
    },
    // 获取微信分享信息
    getWxShareConfig () {
      const {
        title,
        shareInfo: { name, img }
      } = this
      const link = CM.getUrlByDeletingParam(
        {
          autoOauth: false,
          fromWyjhs: false
        },
        location.href
      )
      const desc = `${name}${BC.SHARE_DECS}`
      return {
        action: 'wechat',
        link,
        desc,
        title,
        img,
        success: function () {
          window.WeiyiStatSDK.submit('share')
        }
      }
    },
    // 开关画笔
    handleToggleBoard () {
      if ((this.isForPresentation && this.isHost) || this.recordingState) {
        // 录屏 isHost = true
        if (this.recordingState) {
          this.isHost = !this.isBoardShow
        }
        this.isBoardShow = !this.isBoardShow
        window.WeiyiStatSDK.submit(
          this.isForPresentation ? 'tongping_huabi' : 'huabi'
        )
      }
    },
    // 分享去邀请
    handleToInterpretation (isWechatInvitation) {
      const {
        uuid,
        title,
        theme,
        shareInfo: { name },
        createGroupLock
      } = this
      if (createGroupLock) return
      const mpTitle = `${title}，${name}为您定制`
      this.createGroupLock = true
      API.createGroup({ pbUuid: uuid })
        .then(({ data: { data, success } } = { data: {} }) => {
          if (!success || !data) {
            this.$messagebox.alert('获取讲解房间号失败：', data)
            logger.warn('[分享进房]', '获取讲解房间号失败：', { data, success })
            this.isPreInvitationShow = false
            this.hasPendingInvitation = false
            return
          }
          this.roomId = data
          if (isWechatInvitation) {
            this.handleOpenWechat()
          } else {
            if (!appBridge || !appBridge.checkAppFeature('APP_SHARE')) return
            appBridge.share({
              imgUrl:
                'http://img.winbaoxian.com/autoUpload/planbook/__87080b709204b35.png',
              shareChannel: ['wechat_friends'],
              miniProgramData: {
                webPageUrl: 'http://www.winbaoxian.com/',
                userName: 'gh_db166d39960f',
                path:
                  `/pages/result/index?uuid=${uuid}&roomId=${data}&theme=${theme}` +
                  (BC.isToBApp ? `&app=tob` : '') +
                  (process.env.VUE_APP_REPLAY_VERSION
                    ? `&replayVersion=${process.env.VUE_APP_REPLAY_VERSION}`
                    : ''),
                title: mpTitle,
                description: mpTitle,
                imageUrl:
                  'http://img.winbaoxian.com/autoUpload/planbook/__87080b709204b35.png',
                miniProgramType: APC.reg ? 0 : 2
              }
            })
          }
          this.hasPendingInvitation = true
          // 触发进房
          //  - 计时器(非小程序)
          //  - 分享成功回调
          //  - 后退
          window.setTimeout(() => {
            logger.warn('[分享进房]：', 'timeout 触发')
            this.inviteToPresentation()
          }, 30000)
          if (window.appBridge && appBridge.checkAppFeature('SHARING_AWARE')) {
            appBridge.onSharingDone(res => {
              if (res.success) {
                logger.warn('[分享进房]：', 'onSharingDone 触发')
                this.inviteToPresentation()
              }
            })
          }
          if (
            appBridge &&
            appBridge.checkAppFeature('ON_APP_BACK_TO_INPUT_PAGE')
          ) {
            appBridge.onAppBackToInputPage(() => {
              logger.warn('[分享进房]：', 'onAppBackToInputPage 触发')
              this.inviteToPresentation()
            })
          }
        })
        .finally(() => {
          this.createGroupLock = false
        })
    },
    // 分享进房
    inviteToPresentation () {
      if (!this.hasPendingInvitation || !this.roomId) {
        return
      }
      // 企微、小程序分享后当前页不进房
      if (BC.isWeCom || this.miniprogram) {
        return
      }
      // this.isPreInvitationShow = false
      this.hasPendingInvitation = false
      // this.showBeforeJoinConfirmation = true
      this.gotoPresentationPage()
    },
    // tob - 鹏城
    // 企微
    handleOpenWechat () {
      let { miniprogram, uuid, roomId, theme, shareInfo, title } = this
      const titleStr = encodeURIComponent(`${title}，${shareInfo.name}为您定制`)
      if (window.screenDebug) {
        uuid = '42f87a0c79ef48da9061b97242e52870'
        theme = 'diff'
        roomId = '146542080'
      }
      const appId = 'wx9109094d7509eaf0'
      const path = `/pages/invitation/index?uuid=${uuid}&roomId=${roomId}&theme=${theme}&title=${titleStr}&app=tob`
      // 小程序
      if (miniprogram) {
        // 企微小程序 : 保险师小程序
        const pagePath = BC.isMiniBankInsurance
          ? '/sub/turn/index'
          : '/pages/subscribe/index'
        const miniURL = `${pagePath}?uuid=${uuid}&roomId=${roomId}&theme=${theme}`
        wx.miniProgram.navigateTo({
          url: miniURL
        })
        return
      }
      // 企微
      if (BC.isWeCom && window.WeCom && WeCom.shareToMiniprogram) {
        WeCom.shareToMiniprogram(appId, path)
        return
      }
      if (
        !window.appBridge ||
        !appBridge.checkAppFeature('OPEN_WECHAT_MINI_PROGRAM')
      ) {
        return
      }
      appBridge.gotoNativeView({
        type: 'openMiniProgram',
        data: {
          userName: 'gh_db166d39960f',
          path,
          miniprogramType: APC.reg ? 0 : 2
        }
      })
    },
    // 跳转同屏讲解页面
    gotoPresentationPage () {
      // 跳转前弹窗
      // this.showBeforeJoinConfirmation = false
      window.location.href = CM.setUrlParam(
        'roomId',
        this.roomId,
        window.location.href
      )
    },
    // #历史状态同步
    synchronousHistory (store) {
      const top =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      this.syncDelta({
        top,
        topCorrection: this.inViewPort(top)
      })
      // TODO: 其他状态
      // const { pbData, boardData } = store
      // const contentBody = Object.assign({}, store)
      // delete contentBody.boardData
      // this.syncDelta(contentBody)
      // if (boardData !== undefined && pbData.isBoardShow) {
      //   setTimeout(() => {
      //     if (Array.isArray(store.boardData)) {
      //       store.boardData.forEach(board => {
      //         this.syncDelta({
      //           boardData: board
      //         })
      //       })
      //     } else {
      //       this.syncDelta({
      //         boardData
      //       })
      //     }
      //   }, 1000)
      // }
    },
    // 同屏记录相关信息保存（版本号、房间号、主题）
    savePresentationInfo () {
      const params = {
        groupId: CM.getUrlParam('roomId'),
        theme: this.theme
      }
      if (process.env.VUE_APP_REPLAY_VERSION) {
        params.versionNum = process.env.VUE_APP_REPLAY_VERSION
      }
      API.saveVersionNum(params)
    },
    reset (callback) {
      this.showType = 1
      this.disease = {
        show: false,
        activePath: [],
        height: 0
      }
      this.termsActiveId = null
      this.newInsure = {
        show: false,
        data: {}
      }
      // 责任详情
      this.tmpData.descShow.forEach((prod, index) => {
        this.tmpData.descShow[index] = prod.map(() => false)
      })
      this.replayLoading = true
      setTimeout(() => {
        this.replayLoading = false
        if (typeof callback === 'function') {
          setTimeout(() => {
            callback()
          }, 1000)
        }
      }, 1000)
      // window.scrollTo({
      //   top: 0,
      //   left: 0
      // })
    },
    // 分享
    handleShare () {
      const { asConfig } = this
      if (
        appBridge &&
        appBridge.checkAppFeature('DIRECT_SHOW_ACTION_SHEET') &&
        asConfig
      ) {
        appBridge.directShowActionSheet(asConfig)
      }
    },
    // 打开续保保费详情
    handleOpenNewInsureDetail (value) {
      const { tmpData, uuid } = this
      if (
        !value ||
        !value.insuranceId ||
        !tmpData ||
        !tmpData.resultData ||
        !Array.isArray(tmpData.resultData.productGroupList) ||
        !tmpData.resultData.productGroupList[0]
      ) {
        return
      }
      const prodOrderList = tmpData.resultData.productGroupList[0].prodOrderList
      if (!prodOrderList || !prodOrderList.length) return
      let productId
      prodOrderList.forEach(product => {
        const mulInsOrderList = product.mulInsOrderList
        if (!mulInsOrderList.length) return
        mulInsOrderList.forEach(ins => {
          if (ins.key === value.insuranceId) productId = product.key
        })
      })
      if (!productId) return
      const params = {
        uuid,
        productId,
        insuranceId: value.insuranceId
      }
      let result = {
        conditions: value.conditions
      }
      API.getRenewRateList(params)
        .then(({ data: { data, success } } = { data: {} }) => {
          if (success && data) {
            result.feeList = data
          }
          this.newInsure.data = result
          this.newInsure.show = true
        })
        .catch(() => {
          this.newInsure.data = result
          this.newInsure.show = true
        })
    },
    screenCapture (done) {
      this.exportPbShow = 0
      this.isScreenCaptureShow = false
      setTimeout(() => {
        done().then(() => {
          this.isScreenCaptureShow = true
        })
      }, 1000)
    },
    qaFeedback () {
      if (!this.tsTypeId) return
      const domainName = APC.reg
        ? 'content.winbaoxian.com'
        : 'content.winbaoxian.cn'
      const ax = axios.create({
        baseURL: `https://${domainName}/wx/sales/qa/`
      })
      ax.defaults.withCredentials = true
      const qaType = this.tsType === 'userQaId'
      const params = Object.assign(
        {
          [this.tsType]: Number(this.tsTypeId)
        },
        qaType ? { step: 3 } : null
      )
      ax.post(
        `${qaType ? 'feedback' : 'familyUserQaId'}?appId=${
          BC.wxMpAppid
        }&token=${this.token}`,
        params
      )
    }
  }
}
</script>

<style>
@import 'variable';
@import 'reset';
@import 'base';
@import 'theme/base-normal';
@import 'theme/normal';
@import 'theme/diff-v2';
@import 'layout';

.bx-modal {
  z-index: 1101 !important;
}
</style>
